import { db, collection, addDoc, serverTimestamp, query, where, orderBy, onSnapshot, limit } from '../firebase';

export interface UserEvent {
  id?: string;
  uid: string;
  type: string;
  description: string;
  platform: 'System' | 'Inference' | 'Synthesis' | 'Kinetics' | 'Ship' | 'Design' | 'VisualEditor' | 'Gallery' | 'Marketplace';
  projectId?: string;
  timestamp: any;
}

export const trackUserAction = async (uid: string, type: string, description: string, platform: UserEvent['platform'], projectId?: string) => {
  try {
    await addDoc(collection(db, 'user_events'), {
      uid,
      type,
      description,
      platform,
      projectId: projectId || null,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    console.error("Failed to track user action:", error);
  }
};

export const subscribeToUserEvents = (uid: string, callback: (events: UserEvent[]) => void, maxEvents: number = 5) => {
  const q = query(
    collection(db, 'user_events'),
    where('uid', '==', uid),
    orderBy('timestamp', 'desc'),
    limit(maxEvents)
  );

  return onSnapshot(q, (snapshot) => {
    const events = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as UserEvent[];
    callback(events);
  });
};
